var map = {
	"./amaze.png": 1106,
	"./angel.png": 8285,
	"./angry.png": 5505,
	"./applause.png": 6789,
	"./arrogant.png": 4838,
	"./astonished.png": 9638,
	"./awkward.png": 2147,
	"./bigcry.png": 1462,
	"./blessing.png": 2259,
	"./boo.png": 9570,
	"./bye.png": 154,
	"./candle.png": 6267,
	"./cheer.png": 4701,
	"./comic.png": 101,
	"./cool.png": 9047,
	"./crazy.png": 9865,
	"./cry.png": 7754,
	"./cute.png": 1381,
	"./daze.png": 5546,
	"./dignose.png": 551,
	"./dizzy.png": 8880,
	"./dog.png": 6232,
	"./dontbicker.png": 729,
	"./doubt.png": 652,
	"./drinktea.png": 9820,
	"./dung.png": 888,
	"./embrace.png": 9181,
	"./evil.png": 8406,
	"./facepalmcry.png": 7559,
	"./fallill.png": 3042,
	"./follow.png": 7683,
	"./frown.png": 346,
	"./handshake.png": 9969,
	"./hard.png": 5335,
	"./heart.png": 5330,
	"./hehe.png": 9836,
	"./kiss.png": 1214,
	"./kneel.png": 7877,
	"./kneelcry.png": 5417,
	"./laughcry.png": 4069,
	"./lechery.png": 9504,
	"./letgo.png": 8123,
	"./like.png": 9521,
	"./majestic.png": 1980,
	"./ok.png": 7742,
	"./pathetic.png": 9162,
	"./praise.png": 4976,
	"./reversesmile.png": 9438,
	"./rose.png": 2529,
	"./shutup.png": 1021,
	"./shy.png": 5100,
	"./simper.png": 706,
	"./slap.png": 3266,
	"./sleep.png": 475,
	"./sleepy.png": 2626,
	"./smile.png": 2982,
	"./snap.png": 2644,
	"./split.png": 1346,
	"./stoptalking.png": 2544,
	"./struggle.png": 1453,
	"./sweat.png": 1778,
	"./teethlaugh.png": 797,
	"./titter.png": 9352,
	"./vomit.png": 1379,
	"./wane.png": 3127,
	"./watermelon.png": 2110
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7451;